import { withConfig, getApi } from "./index";
const api = getApi("utils");

export const verifySignedUrl = withConfig((payload, conf) => {
  const config = conf({
    url: `/signed-url/verify`,
    method: "POST",
    data: payload,
  });

  return api(config);
});

export const fetchParams = withConfig(() => {
  return api({
    url: "/params",
    method: "GET",
  });
});

export const fetchCloudDocument = withConfig((data, conf) => {
  const { ...payload } = data;
  return api({
    url: "/cloud-document/preview",
    method: "GET",
    params: payload,
    responseType: "blob",
  });
});
